export const designations = {
    Captain: {
        rank: 1,
        designation: 'Captain',
    },
    'Chief Officer': {
        rank: 2,
        designation: 'Chief Officer',
    },
    'Second Officer': {
        rank: 4,
        designation: 'Second Officer',
    },
    'Third Officer': {
        rank: 5,
        designation: 'Third Officer',
    },
    'Chief Engineer': {
        rank: 3,
        designation: 'Chief Engineer',
    },
    'First Engineer': {
        rank: 6,
        designation: 'First Engineer',
    },
    'Second Engineer': {
        rank: 7,
        designation: 'Second Engineer',
    },
    'Third Engineer': {
        rank: 8,
        designation: 'Third Engineer',
    },
    'Fourth Engineer': {
        rank: 9,
        designation: 'Fourth Engineer',
    },
    // MST: {
    //     rank: 1,
    //     designation: 'Captain',
    // },
    // 'C/O': {
    //     rank: 2,
    //     designation: 'Chief Officer',
    // },
    // '2/O': {
    //     rank: 4,
    //     designation: 'Second Officer',
    // },
    // '3/O': {
    //     rank: 5,
    //     designation: 'Third Officer',
    // },
    // 'C/E': {
    //     rank: 3,
    //     designation: 'Chief Engineer',
    // },
    // '1/E': {
    //     rank: 6,
    //     designation: 'First Engineer',
    // },
    // '2/E': {
    //     rank: 7,
    //     designation: 'Second Engineer',
    // },
    // '3/E': {
    //     rank: 8,
    //     designation: 'Third Engineer',
    // },
    EE2: {
        rank: 10,
        designation: 'EE2',
    },
    ECD: {
        rank: 10,
        designation: 'ECD',
    },
    BSN: {
        rank: 10,
        designation: 'BSN',
    },
    'A/B': {
        rank: 10,
        designation: 'A/B',
    },
    'O/S': {
        rank: 10,
        designation: 'O/S',
    },
    OLR: {
        rank: 10,
        designation: 'OLR',
    },
    WPR: {
        rank: 10,
        designation: 'WPR',
    },
    'C/K': {
        rank: 10,
        designation: 'C/K',
    },
    MSM: {
        rank: 10,
        designation: 'MSM',
    },
    MSN: {
        rank: 10,
        designation: 'MSN',
    },

    FTC: {
        rank: 10,
        designation: 'FTC',
    },
    DFE: {
        rank: 10,
        designation: 'DFE',
    },
    EE1: {
        rank: 10,
        designation: 'EE1',
    },
    'J/E': {
        rank: 10,
        designation: 'J/E',
    },
    'G/E': {
        rank: 10,
        designation: 'G/E',
    },
    FTB: {
        rank: 10,
        designation: 'FTB',
    },
    FT1: {
        rank: 10,
        designation: 'FT1',
    },
    SUP: {
        rank: 10,
        designation: 'SUP',
    },
    EEC: {
        rank: 10,
        designation: 'EEC',
    },
    SCO: {
        rank: 2,
        designation: 'SCO',
    },
    S1E: {
        rank: 10,
        designation: 'S1E',
    },
    EE3: {
        rank: 10,
        designation: 'EE3',
    },
    DCT: {
        rank: 10,
        designation: 'DCT',
    },
    ETO: {
        rank: 10,
        designation: 'ETO',
    },
    PMN: {
        rank: 10,
        designation: 'PMN',
    },
    TEC: {
        rank: 10,
        designation: 'TEC',
    },
    FTA: {
        rank: 10,
        designation: 'FTA',
    },
    FTR: {
        rank: 10,
        designation: 'FTR',
    },
    '2/OS': {
        rank: 10,
        designation: '2/OS',
    },
    LFT: {
        rank: 10,
        designation: 'LFT',
    },
    EPS: {
        rank: 10,
        designation: 'EPS',
    },
    ETR: {
        rank: 10,
        designation: 'ETR',
    },
    SPM: {
        rank: 10,
        designation: 'SPM',
    },
    SFT: {
        rank: 10,
        designation: 'SFT',
    },
    'J/O': {
        rank: 10,
        designation: 'J/O',
    },
    GE: {
        rank: 10,
        designation: 'GE',
    },
};

export const ranks = {
    1: 'Captain',
    2: 'Chief Officer',
    3: 'Chief Engineer',
    4: 'Second Officer',
    5: 'Third Officer',
    6: 'First Engineer',
    7: 'Second Engineer',
    8: 'Third Engineer',
};
